"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractValidationPlugin_1 = __importDefault(require("./AbstractValidationPlugin"));
console.debug('INFO PatternValidatonPlugin.ts loaded');
var PatternValidationPlugin = /** @class */ (function (_super) {
    __extends(PatternValidationPlugin, _super);
    function PatternValidationPlugin(field) {
        var _this = _super.call(this, field) || this;
        _this.field = field;
        return _this;
    }
    PatternValidationPlugin.prototype.isValid = function () {
        return !this.field.validity.patternMismatch;
    };
    PatternValidationPlugin.prototype._getMessageAttribute = function () {
        return 'data-pattern-error-message';
    };
    PatternValidationPlugin.prototype._getDefaultMessage = function () {
        return 'Your input does not match the requirements.';
    };
    return PatternValidationPlugin;
}(AbstractValidationPlugin_1.default));
exports.default = PatternValidationPlugin;
